import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';
import VueTouch from 'vue-touch';
import { router } from './router.js';

Vue.config.productionTip = false

/*
 *  Vue Resource setup
 */
Vue.use( VueResource );

Vue.http.options.root = process.env.VUE_APP_API_URL;
Vue.http.headers.common['Authorization'] = ''; 

/*
 * Vue Touch and Hammer setup
 */
// Enable user text select 
delete Hammer.defaults.cssProps.userSelect;
Vue.use( VueTouch, {name: 'v-touch'} );

VueTouch.config.swipe = {
  direction: 'horizontal'
};

new Vue({
  router,
  render: (h) => h( App )

}).$mount('#app')
